import { Box, Button, TextField } from "@mui/material";
import { useSnackbar } from "notistack";
import { useState } from "react";

import { useTranslation } from "react-i18next";
import { useCheckMailingIntegrationMutation } from "../../integrationsApiSlice";

export const CheckConnection = () => {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const [value, setValue] = useState("");
	const [error, setError] = useState(false);

	const [checkMailingIntegrationMutation, { isLoading }] =
		useCheckMailingIntegrationMutation();

	const handleSubmit = async () => {
		if (!value) {
			setError(true);
			enqueueSnackbar(t("enter_email_address"), {
				variant: "error",
			});
			return;
		}
		// check if value is email
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(value)) {
			setError(true);
			enqueueSnackbar(t("enter_valid_email_address"), {
				variant: "error",
			});
			return;
		}

		await checkMailingIntegrationMutation({ testEmailTo: value })
			.unwrap()
			.then((_payload) => {
				enqueueSnackbar(t("successfully_sent_message_check_your_email"), {
					variant: "success",
				});
			})
			.catch((error) => {
				if (error?.data?.errors) {
					const errors = error.data.errors;
					Object.entries(errors).forEach(([key, message]) => {
						setError(key);
						enqueueSnackbar(message[0], {
							variant: "error",
							preventDuplicate: true,
						});
					});
				} else {
					enqueueSnackbar(error?.data?.message || t("default_error"), {
						variant: "error",
						preventDuplicate: true,
					});
				}
			});
	};

	return (
		<Box
			sx={{
				marginTop: "20px",
				width: "calc(50% - 20px)",
				display: "flex",
				justifyContent: "start",
				border: "1px solid #e0e0e0",
				padding: "20px",
				gap: "8px",
			}}
		>
			<TextField
				placeholder={t("enter_email_address_to_check_connection")}
				size="small"
				value={value}
				variant="outlined"
				fullWidth
				error={error}
				onChange={(e) => setValue(e.target.value)}
				slotProps={{
					inputLabel: { shrink: true },
				}}
			/>
			<Button
				onClick={handleSubmit}
				loading={isLoading}
				type="submit"
				variant="contained"
				sx={{ whiteSpace: "nowrap" }}
			>
				{t("check_connection")}
			</Button>
		</Box>
	);
};
